import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class OrderService {

  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  addToCart(id) {
    debugger;
    const product = {
      productId: id
    }
    return this.http.post(this.rootUrl + '/api/Order/AddToCart', product);
  }

  getUserCartItems() {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.get(this.rootUrl + '/api/Order/GetUserCartItems', requestOptions);
  }

  removeFromCart(id) {

    const cart = {
      cartItemId: id
    }
    return this.http.post(this.rootUrl + '/api/Order/RemoveFromCart', cart);
  }

  placeorder(cartdata) {
    return this.http.post(this.rootUrl + '/api/Order/PlaceOrder', cartdata);
  }

  getPlacedOrderItem(orderno) {

    const order = {
      orderNumber: orderno
    }
    return this.http.post(this.rootUrl + '/api/Order/GetPlacedOrderItem', order);
  }

  confirmOrder(form) {
    return this.http.post(this.rootUrl + '/api/Order/ConfirmOrder', form);
  }

  getMyOrderList() {
    return this.http.get(this.rootUrl + '/api/Order/GetMyOrdersList');
  }

  getOrderItemForEdit(orderno) {
    const order = {
      orderNumber: orderno
    }
    return this.http.post(this.rootUrl + '/api/Order/GetOrderItemForEdit', order);
  }

  addItemsToOrder(orderno, productid) {
    const order = {
      orderNumber: orderno,
      productId: productid
    }
    return this.http.post(this.rootUrl + '/api/Order/AddItemsToOrder', order);
  }

  removeFromOrder(id) {

    const cart = {
      cartItemId: id
    }
    return this.http.post(this.rootUrl + '/api/Order/RemoveFromOrder', cart);
  }

  updateorder(cartdata) {
    return this.http.post(this.rootUrl + '/api/Order/UpdateOrder', cartdata);
  }

  getAllOrderList() {
    return this.http.get(this.rootUrl + '/api/Order/GetAllOrdersList');
  }

  cancelOrder(orderno) {
    const order = {
      orderNumber: orderno
    }
    return this.http.post(this.rootUrl + '/api/Order/CancelOrder', order);
  }

  repeatorder(cartdata) {
    return this.http.post(this.rootUrl + '/api/Order/RepeatOrder', cartdata);
  }

  filledOrder(orderno) {
    const order = {
      orderNumber: orderno
    }
    return this.http.post(this.rootUrl + '/api/Order/FilledOrder', order);
  }

  getMyPendingOrder() {
    return this.http.get(this.rootUrl + '/api/Order/GetMyPendingOrder');
  }

  getMyFilledOrder() {
    return this.http.get(this.rootUrl + '/api/Order/GetMyFilledOrder');
  }

  getMyCancelledOrder() {
    return this.http.get(this.rootUrl + '/api/Order/GetMyCancelledOrder');
  }

  getAllPendingOrder() {
    return this.http.get(this.rootUrl + '/api/Order/GetAllPendingOrder');
  }

  getAllFilledOrder() {
    return this.http.get(this.rootUrl + '/api/Order/GetAllFilledOrder');
  }

  getAllCancelledOrder() {
    return this.http.get(this.rootUrl + '/api/Order/GetAllCancelledOrder');
  }

  // getHrOrderReport()
  // {
  //   return this.http.get(this.rootUrl + '/api/Order/GetHrOrderUploadReport');
  // }

  updateCartItems(cartdata) {
    return this.http.post(this.rootUrl + '/api/Order/UpdateCartItems', cartdata);
  }

}
